module.exports = __webpack_public_path__ + "img/article_1_5.4ca34a33.png";